import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=38fb2e92"
import script from "./Offer.vue?vue&type=script&lang=js"
export * from "./Offer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports